import { useState, useRef, useEffect } from "react";

const videos = [
  { id: "jpyJtDDy-04", title: "#StoriesOfMG | MG Comet EV | Bidyut Sharma" },
  { id: "CqHEkYPTMEI", title: "Move The Way You Like | MG Comet EV - The Street Smart Car" },
  { id: "DZvD6KpgWlI", title: "Move The Way You Like | MG Comet EV - The Street Smart Car" },
  { id: "47VV3AK_wAE", title: "Space For Your World | MG Comet EV - The Street Smart Car" },
  { id: "0WPjvRPwjN4", title: "Space For Your World | MG Comet EV - The Street Smart Car" },
  { id: "nkn9UIj4E2g", title: "UNIMO x MG Comet EV | Interaction with Moms" },
  { id: "ms7_e43uZTM", title: "UNIMO x MG Comet EV | Wrap Up" },
  { id: "fLKmWm4CcZU", title: "Space For Your World | MG Comet EV - The Street Smart Car" },
  { id: "qb_hi2u29EQ", title: "Space For Your World | MG Comet EV - The Street Smart Car" },
  { id: "qb_hi2u29EQ", title: "Move The Way You Like | MG Comet EV - The Street Smart Car" },
];

const GAP = 20;
const TITLE_HEIGHT = 68;

export default function MGCometTestimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [containerWidth, setContainerWidth] = useState(0);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!wrapperRef.current) return;
    const ro = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setContainerWidth(entry.contentRect.width);
      }
    });
    ro.observe(wrapperRef.current);
    setContainerWidth(wrapperRef.current.getBoundingClientRect().width);
    return () => ro.disconnect();
  }, []);

  const visibleCount = containerWidth > 0 && containerWidth < 580 ? 1 : 2;
  const cardWidth = containerWidth > 0
    ? (containerWidth - GAP * (visibleCount - 1)) / visibleCount
    : 0;
  const maxIndex = Math.max(0, videos.length - visibleCount);

  useEffect(() => {
    setCurrentIndex((i) => Math.min(i, maxIndex));
  }, [maxIndex]);

  const prev = () => setCurrentIndex((i) => Math.max(0, i - 1));
  const next = () => setCurrentIndex((i) => Math.min(maxIndex, i + 1));

  const iframeHeight = cardWidth > 0 ? Math.round(cardWidth * 0.5625) : 0;
  const cardHeight = iframeHeight + TITLE_HEIGHT;
  const translateX = currentIndex * (cardWidth + GAP);

  return (
    <div style={{ fontFamily: "'Georgia', serif", background: "#fff", padding: "60px 0 80px" }}>
      <style>{`
        .mgt-card {
          border-radius: 4px;
          overflow: hidden;
          background: #fff;
          box-shadow: 0 2px 12px rgba(0,0,0,0.08);
          transition: box-shadow 0.3s, transform 0.25s;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
          flex-grow: 0;
        }
        .mgt-card:hover {
          box-shadow: 0 8px 32px rgba(192,0,29,0.13);
          transform: translateY(-3px);
        }
        .mgt-nav-btn {
          width: 46px; height: 46px;
          border-radius: 10px;
          background: #c0001d;
          border: none; cursor: pointer;
          display: flex; align-items: center; justify-content: center;
          color: #fff; font-size: 1.5rem; font-weight: bold;
          transition: background 0.2s, transform 0.15s;
          flex-shrink: 0;
        }
        .mgt-nav-btn:hover:not(:disabled) { background: #900015; transform: scale(1.07); }
        .mgt-nav-btn:disabled { opacity: 0.35; cursor: not-allowed; }
        .mgt-dot {
          width: 9px; height: 9px; border-radius: 50%;
          background: #ddd; border: none; padding: 0;
          cursor: pointer; transition: background 0.2s, transform 0.2s;
        }
        .mgt-dot.active { background: #c0001d; transform: scale(1.35); }
      `}</style>

      <h2 style={{
        textAlign: "center", color: "#c0001d",
        fontSize: "clamp(1.3rem, 3.5vw, 2.1rem)",
        fontWeight: "700", marginBottom: "40px",
        fontFamily: "'Georgia', serif", letterSpacing: "0.01em",
      }}>
        Customer Testimonials
      </h2>

      <div style={{ maxWidth: "1320px", margin: "0 auto", padding: "0 20px" }}>
        {/* Measured overflow wrapper */}
        <div ref={wrapperRef} style={{ overflow: "hidden", width: "100%" }}>
          <div style={{
            display: "flex",
            gap: `${GAP}px`,
            transform: `translateX(-${translateX}px)`,
            transition: "transform 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
            willChange: "transform",
          }}>
            {videos.map((v, i) => (
              <div
                key={i}
                className="mgt-card"
                style={{
                  width: `${cardWidth}px`,
                  minWidth: `${cardWidth}px`,
                  maxWidth: `${cardWidth}px`,
                  height: `${cardHeight}px`,
                }}
              >
                {/* Exact pixel-height 16:9 iframe */}
                <div style={{
                  width: "100%", height: `${iframeHeight}px`,
                  background: "#000", flexShrink: 0, position: "relative",
                }}>
                  <iframe
                    src={`https://www.youtube.com/embed/${v.id}`}
                    title={v.title}
                    allowFullScreen
                    loading="lazy"
                    style={{
                      position: "absolute", top: 0, left: 0,
                      width: "100%", height: "100%", border: "none",
                    }}
                  />
                </div>

                {/* Fixed-height title — identical on every card */}
                <div style={{
                  height: `${TITLE_HEIGHT}px`,
                  padding: "10px 10px 8px",
                  fontSize: "0.9rem", fontWeight: "600",
                  fontFamily: "'Arial', sans-serif", color: "#222",
                  lineHeight: 1.45, boxSizing: "border-box",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  WebkitBoxOrient: "vertical",
                }}>
                  {v.title}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Navigation */}
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "14px", marginTop: "32px" }}>
          <button className="mgt-nav-btn" onClick={prev} disabled={currentIndex === 0} aria-label="Previous">‹</button>
          
          <button className="mgt-nav-btn" onClick={next} disabled={currentIndex >= maxIndex} aria-label="Next">›</button>
        </div>
      </div>
    </div>
  );
}